import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import Validate from '../lib/validate';
import Settings from '../lib/settings';
// import {Editor} from 'react-draft-wysiwyg';
// import {EditorState, convertToRaw, ContentState} from 'draft-js';
// import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
// import htmlToDraft from 'html-to-draftjs';
import * as Actions from '../actions';
import {connect} from 'react-redux';

class ShippingPaying extends Component {

  constructor(props) {
    super(props);

    this.state = {

      shipping: {
        name: '',
        description: '',
        price: '',
        free: 0
      },
      payment: {
        name: '',
        description: '',
        price: '',
        free: 0
      },
      shippingList: [],
      paymentList: [],
      formMessage: [],
      isUpdating: {shipping: false, payment: false},
      canScroll: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.loadShipping = this.loadShipping.bind(this);
    this.loadPayments = this.loadPayments.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);

    //this.addFormMessage = this.handleSubmit.bind(this);
  }

  componentDidMount() {

    window.scrollTo(0, this.props.menuPosition);
    this.loadShipping();
    this.loadPayments();
    //window.addEventListener('scroll', function() {console.log(window.scrollY);});

  }

  loadShipping() {
    fetch('/api/shipping/', Settings.fetchParams('GET')).then(res => res.json()).then(json => {
      if (typeof json !== "undefined" && typeof json.error === "undefined") {
        this.setState({shippingList: json});
      }
    });
  }

  loadPayments() {
    fetch('/api/payment/', Settings.fetchParams('GET')).then(res => res.json()).then(json => {
      if (typeof json !== "undefined" && typeof json.error === "undefined") {
        this.setState({paymentList: json});
      }

    });
  }

  componentWillReceiveProps(newProps) {
    window.scrollTo(0, this.props.menuPosition);

  }

  addWrongInputClass(name) {
    ReactDOM.findDOMNode(this.refs[name]).classList.add(Settings.wrongInput);
  }

  addFormMessage(message) {

    this.setState(prevState => ({
      formMessage: [
        ...prevState.formMessage,
        message
      ],
      canScroll: true
    }));
  }

  cancelEdit() {
    this.setState({

      shipping: {
        name: '',
        description: '',
        price: '',
        free: 0
      },
      payment: {
        name: '',
        description: '',
        price: '',
        free: 0
      },
      isUpdating: {shipping: false, payment: false}
    });
  }

  handleChange(event, item) {

    let oldState = this.state[item];

    oldState[event.target.name] = event.target.value;

    this.setState({[item]: oldState});
    ReactDOM.findDOMNode(this.refs[item + event.target.name]).classList.remove(Settings.wrongInput);
  }

  handleCheckboxChange(event, shippingId) {

    let method = "DELETE";
    if (event.target.checked) {
      method = "POST"
    }

    fetch("/api/shipping/" + shippingId + "/" + event.target.value, Settings.fetchParams(method)).then(res => {
      if (res.ok) {
        res.json().then(json => {

          if (!json.error) {

            this.setState({shippingList: json});
            this.loadPayments();
          } else {
            alert("Chyba při úpravě platby");
          }
        })
      } else {
        alert("Chyba při úpravě platby");
      }
    });

  }

  handleEdit(item, what) {
    let isUpdating = this.state.isUpdating;
    isUpdating[what] = true;
    this.setState({
      [what]: item,
      isUpdating: isUpdating
    }, () => {
      ReactDOM.findDOMNode(this.refs[what]).scrollIntoView();
    });

  }

  handleDelete(id, what) {
    let confirmText;

    if (what === "shipping") {
      confirmText = "Opravdu chcete smazat dopravu?";
    } else {
      confirmText = "Opravdu chcete smazat platbu?";
    }

    let canDelete = window.confirm(confirmText);

    if (canDelete) {
      //this.props.dispatch(Actions.loader(true));
      fetch("/api/" + what + "/" + id, Settings.fetchParams('DELETE')).then(res => {
        this.props.dispatch(Actions.loader(false));
        if (res.ok) {
          res.json().then(json => {
            //console.log(json);
            if (!json.error && json.deleted) {
              this.loadShipping();
              this.loadPayments();
            } else {
              alert("Error");
            }
          })
        } else {
          alert("Error2");
        }
      });
    }
  }

  handleSubmit(event, itemIn) {
    //console.log(this.state[itemIn]);
    event.preventDefault();
    let errorCheck = true;

    this.setState({formMessage: []});

    if (!Validate.shippingPayment(this.state[itemIn].name, "name")) {
      this.addFormMessage("Pro přidání prosím vyplňte název");
      errorCheck = false;
      this.addWrongInputClass(itemIn + "name");
    }

    if (!Validate.shippingPayment(this.state[itemIn].description, "description")) {
      this.addFormMessage("Pro přidání prosím vyplňte popis");
      errorCheck = false;
      this.addWrongInputClass(itemIn + "description");
    }

    if (!Validate.shippingPayment(this.state[itemIn].price, "price")) {
      this.addFormMessage("Pro přidání prosím vyplňte cenu. 0 pro zdarma.");
      errorCheck = false;
      this.addWrongInputClass(itemIn + "price");
    }

    if (!Validate.shippingPayment(this.state[itemIn].free, "free")) {
      this.addFormMessage("Pro přidání prosím vyplňte od jaké částky je zdarma. Vyplňte 0 pokud zdarma nelze.");
      errorCheck = false;
      this.addWrongInputClass(itemIn + "free");
    }

    if (errorCheck) {
      //this.props.dispatch(Actions.loader(true));

      let item = {
        name: this.state[itemIn].name,
        description: this.state[itemIn].description,
        price: this.state[itemIn].price,
        free: this.state[itemIn].free
      };

      if (this.state.isUpdating[itemIn]) {
        item._id = this.state._id
      }

      if (Validate.shippingPayment(item, "for_insert")) {

        var sucessText;
        if (this.state.isUpdating[itemIn]) {
          sucessText = "Změny uloženy!";
        } else {
          sucessText = "Přidáno!";
        }

        var fetchAdd;
        if (this.state.isUpdating[itemIn]) {
          fetchAdd = '/api/' + itemIn + '/' + this.state[itemIn]._id;
        } else {
          fetchAdd = '/api/' + itemIn;
        }

        fetch(fetchAdd, Settings.fetchParams('POST', item)).then(res => {
          this.props.dispatch(Actions.loader(false));
          if (res.ok) {
            res.json().then(json => {
              if (!json.error) {
                this.loadShipping();
                this.loadPayments();
                this.cancelEdit();
                alert(sucessText);

                //window.scrollTo(0, this.props.menuPosition);
                //ReactDOM.findDOMNode(this.refs["addProduct" + itemIn]).innerHTML = '<h2 class="addSuccess">' + sucessText + '</h2>';
              } else {
                //console.log(json);
              }
            })
          } else {
            alert("Error");
          }
        });

      } else {
        alert("Vyplňte korektně formulář..");
      }

    }

  }

  render() {
    if (this.state.formMessage.length > 0 && this.state.canScroll) {
      window.scrollTo(0, this.props.menuPosition);
      this.setState({canScroll: false});
    }

    const formErrorMessages = this.state.formMessage.map((item, index) => <p key={index}>{item}</p>);

    const paymentToShippingList = (shippingIndex) => {
      let list = this.state.paymentList.map((item, index) => <div key={index}><input type="checkbox" checked={this.state.shippingList[shippingIndex].payments.includes(item._id)} value={item._id} onChange={(e) => {
          this.handleCheckboxChange(e, this.state.shippingList[shippingIndex]._id)
        }}/>{item.name}</div>);
      return list;
    };
    const shippingPayingList = this.state.shippingList.map((item, index) => <div className="shippingPayingList" key={index}>
      <p>{item.name}</p>
      <div className="paymentList">Možnosti platby: {paymentToShippingList(index)}</div>
    </div>);

    const shippingList = this.state.shippingList.map((item, index) => <div className="shippingList" key={index}>
      <p>
        <strong>{item.name} </strong>
        -
        <i className="fas fa-edit" onClick={() => {
            this.handleEdit(item, "shipping")
          }}></i>
        <i className="fas fa-trash-alt" onClick={() => {
            this.handleDelete(item._id, "shipping")
          }}></i>
      </p>
      <p>Popis: {item.description}</p>
      <p>Cena: {item.price}, Zdarma od: {item.free}</p>
    </div>);

    const paymentList = this.state.paymentList.map((item, index) => <div className="shippingList" key={index}>
      <p>
        <strong>{item.name} </strong>
        -
        <i className="fas fa-edit" onClick={() => {
            this.handleEdit(item, "payment")
          }}></i>{
          item.canDelete
            ? <i className="fas fa-trash-alt" onClick={() => {
                  this.handleDelete(item._id, "payment")
                }}></i>
            : ""
        }</p>
      <p>Popis: {item.description}</p>
      <p>Cena: {item.price}, Zdarma od: {item.free}</p>
    </div>);

    const addForm = (item) => {
      return (<div className="form" ref={item}>
        <div ref={"addProduct" + item}>
          <h2>
            {
              this.state.isUpdating[item]
                ? "Upravit "
                : "Přidat "
            }
            {
              item === "shipping"
                ? "dopravu"
                : "platbu"
            }:
          </h2>

          <div className="formErrorMessages">
            {formErrorMessages}
          </div>
          <form onSubmit={(e) => {
              this.handleSubmit(e, item)
            }}>
            <div className="row">
              <div className="col100">
                <div className="formLabel">Název</div>
                <div className="formInput"><input type="text" name="name" ref={item + "name"} value={this.state[item].name} onChange={(e) => {
          this.handleChange(e, item)
        }} required="required"/></div>
              </div>
              <div className="col100">
                <div className="formLabel">Popis</div>
                <div className="formInput"><input type="text" name="description" ref={item + "description"} value={this.state[item].description} onChange={(e) => {
          this.handleChange(e, item)
        }} required="required"/></div>
              </div>
              <div className="col50">
                <div className="formLabel">Cena</div>
                <div className="formInput"><input type="text" name="price" ref={item + "price"} value={this.state[item].price} onChange={(e) => {
          this.handleChange(e, item)
        }} required="required"/></div>
              </div>
              <div className="col50">
                <div className="formLabel">Zdarma od (0 pro není)</div>
                <div className="formInput"><input type="text" name="free" ref={item + "free"} value={this.state[item].free} onChange={(e) => {
          this.handleChange(e, item)
        }} required="required"/></div>
              </div>

            </div>
          </form>

          <div className="col100">
            <button type="submit" onClick={(e) => {
                this.handleSubmit(e, item)
              }}>{
                this.state.isUpdating[item]
                  ? "Uložit změny"
                  : "Přidat"
              }</button>
            {
              this.state.isUpdating[item]
              ? <button onClick={this.cancelEdit}>Zrušit</button>
              : ""
            }
          </div>
        </div>
      </div>);
    }

    return (<div>{addForm("shipping")}
      {addForm("payment")}
      <div className="shippingPaymentSettings">
        <h2>Navázání plateb na dopravu</h2>{shippingPayingList}</div>
      <div className="shippingPaymentSettings">
        <h2>Seznam dopravy</h2>{shippingList}</div>
      <div className="shippingPaymentSettings">
        <h2>Seznam plateb</h2>
        <p>*Nelze mazat platby přiřazené k dopravě.</p>
        {paymentList}
          </div>

    </div>);
  }
}
function mapStateToProps(state) {
  return {admin: state.admin, menuPosition: state.menuPosition};
}
export default connect(mapStateToProps)(ShippingPaying);



// WEBPACK FOOTER //
// ./src/pages/ShippingPaying.js